import { useCallback, useContext } from 'react'
import { GlobalContext } from 'src/contextAPI/globalContext'
import { TableName } from 'src/pages/index.type'

export function useClearUserLocalStorage() {
  const { oid } = useContext(GlobalContext)
  return useCallback(() => {
    const tables = [TableName.ReportManagement, TableName.AuditLogs, TableName.CategoryManagement, TableName.FrequentReport, TableName.UserManagement]

    tables.forEach(table => {
      localStorage.removeItem(`${table}/${oid}`)
    })
  }, [])
}
